import { STATUS_BADGES, StatusBadge } from "@/shared/components/StatusBadge";
import { CustomFieldStatus } from "@/shared/domain/customFields";

interface CustomFieldStatusChipProps {
  status: CustomFieldStatus;
}

export function CustomFieldStatusChip({ status }: CustomFieldStatusChipProps) {
  return <StatusBadge status={STATUS_BADGES.customField[status]} />;
}
